import { gql } from "@grandvisionhq/graphql";
const GET_MANUFACTURER_BY_KEY = gql`
  query GetManufacturerByKey($key: String!) {
    manufacturer(key: $key) {
      ... on ManufacturerSuccessResponse {
        result {
          name
          address {
            line1
            line2
            line3
            zipCode
            city
            country
            email
            contactUrl
          }
        }
      }
    }
  }
`;
export {
  GET_MANUFACTURER_BY_KEY
};
//# sourceMappingURL=get-manufacturer-by-key.js.map
